// @copyright 2006 - 2021 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'portal-invitation.activation.message.error': 'This invitation has expired.',
};
